import { CreateFinancialAccountParams, MutationResponse } from './interfaces';
import { orgsRequest } from './request';

const CREATE_FINANCIAL_ACCOUNT_NODE_MUTATION = `
mutation CreateFinancialAccount(
    $kybId: ID!
    $orgId: ID!
    $processor: Processor!
    $acctId: ID
    $applicationId: ID
    $customerId: ID
    $status: FinAcctStatus
    $stripeEnv: FinAcctStripeEnv!
  ) {
    financialAccountResponse: financialAcctCreate(
      kybId: $kybId
      orgId: $orgId
      processor: $processor
      acctId: $acctId
      applicationId: $applicationId
      customerId: $customerId
      status: $status
      stripeEnv: $stripeEnv
    ) {
      success
      errors {
        type
        message
      }
      properties {
        finAcctId
      }
    }
  }
`;

export const createFinancialAccountNode = async (
  createFinancialAccountParams: CreateFinancialAccountParams,
): Promise<MutationResponse> => {
  const financialAccountRes = await orgsRequest(
    CREATE_FINANCIAL_ACCOUNT_NODE_MUTATION,
    createFinancialAccountParams,
  );
  const financialAccountJson = await financialAccountRes.json();

  if (financialAccountJson.errors) {
    throw new Error(
      `Could not create a financial account ${createFinancialAccountParams.orgId}`,
    );
  }
  return financialAccountJson.data.financialAccountResponse;
};
